import { useState, useEffect } from 'react';

export default function useAreaMonitoringDimensions(ref) {
  const [height, setHeight] = useState(ref.current?.clientHeight ?? 0);
  const [width, setWidth] = useState(ref.current?.clientWidth ?? 0);
  useEffect(() => {
    function onResize() {
      if (!ref.current) {
        return;
      }

      let timeout;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const { clientHeight, clientWidth } = ref.current;
        setHeight(clientHeight);
        setWidth(clientWidth);
      }, 500);
    }

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    let timeout;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const { clientHeight, clientWidth } = ref.current;
      setHeight(clientHeight);
      setWidth(clientWidth);
    }, 500);
  }, [ref]);

  return {
    width,
    height,
  };
}
